// Globals
import React, { useCallback } from 'react';

// UI
import { Modal } from 'antd';

// Locals
import cheatSheet1 from '../../studio/assets/newBrandingIllustrations/ai-waves.png';
import cheatSheet2 from '../../studio/assets/dashboard/cheatSheet2.png';
import cheatSheet3 from '../../studio/assets/newBrandingIllustrations/giide-share-.jpg';

import styles from '../Components.module.css';

const items = [
  {
    image: cheatSheet1,
    title: 'Add Audio',
    text: 'Using our interactive tool, or your application of choice, record your audio. Write a script if you want or speak off the cuff—either works! When finished, upload it into the studio and proceed to the next step.',
  },
  {
    image: cheatSheet2,
    title: 'Create Feed',
    text: 'Attach links, social profiles, images and more to your words in order to create the visual feed that will accompany your audio. Think about what you really want your audience to remember and take away.',
  },
  {
    image: cheatSheet3,
    title: 'Preview & Publish',
    text: 'When you’re all finished, add a cover image to your giide and edit the details if you haven’t already, then get a shareable link to post on your social media channels or send to friends!',
  },
];

const CheatSheetModal: React.FC<{
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}> = ({ showModal, setShowModal }) => {
  const cheatSheetItems = useCallback(() => {
    let cheatItems: any[] = [];
    for (let i = 0; i < 3; i++) {
      cheatItems.push(
        <div className={styles.cheatSheetItemWrapper} key={items[i].title}>
          <img
            className={styles.cheatSheetIcon}
            src={items[i].image}
            alt={`cheat sheet ${i}`}
          />
          <div>
            <div className={styles.cheatSheetItemTitle}>
              {i + 1}. {items[i].title}
            </div>
            <div className={styles.cheatSheetItemText}>{items[i].text}</div>
          </div>
        </div>
      );
    }
    return cheatItems;
  }, []);

  return (
    <Modal
      title={null}
      open={showModal}
      footer={null}
      className={styles.cheatSheetModal}
      width={'396.75pt'}
      onCancel={() => setShowModal(false)}
    >
      <div className={styles.cheatSheetWrapper}>
        <div className={styles.cheatSheetTitle}>The Cheat Sheet</div>
        <div className={styles.cheatSheetItemsWrapper}>{cheatSheetItems()}</div>
      </div>
    </Modal>
  );
};

export default CheatSheetModal;
